<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    progress: number
    barClasses?: string | string[]
    allowOverflowLabel?: boolean
  }>(),
  {
    allowOverflowLabel: false
  }
)

const normalizedProgress = computed(() => {
  if (props.progress > 1) return 1

  if (props.progress < 0) return 0

  return props.progress
})

const displayProgress = computed(() =>
  props.allowOverflowLabel ? Math.max(props.progress, 0) : normalizedProgress.value
)
</script>

<template>
  <div class="tw-w-full tw-rounded-full tw-bg-gray-100">
    <div
      class="tw-truncate tw-rounded-full tw-bg-riser-blue tw-px-3 tw-py-2 tw-text-sm tw-font-bold tw-text-white tw-transition-all tw-duration-1000"
      :class="props.barClasses"
      :style="{ width: normalizedProgress * 100 + '%' }"
      style="min-width: min-content"
    >
      <slot name="label"> {{ Math.round(displayProgress * 100) }} % </slot>
    </div>
  </div>
</template>
